import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { filterTypes } from '../constants'

const FilterTypeSelector = ({ onChange, value, disabled, source }) => {
  const { t } = useTranslation()

  const menuItems = filterTypes
    .filter(type => type.source === source)
    .map(type => ({
      label: t(type.label),
      value: type.value,
    }))

  return (
    <div>
      <ComboBox
        fullWidth
        menuItems={menuItems}
        label={t('Filtrar por')}
        value={value}
        handleChange={e => onChange(e.target.value)}
        disabled={disabled}
      />
    </div>
  )
}

export default FilterTypeSelector
